var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('backhaul-table',{attrs:{"site-id":_vm.siteId,"provider":false,"site-data":_vm.siteData,"sharer-id":_vm.sharerId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }